import React from 'react'

const BackButton = () => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.29292 0.292908L7.70714 1.70712L3.41424 6.00001L7.70714 10.2929L6.29292 11.7071L0.585815 6.00001L6.29292 0.292908Z"
        fill="#241C15"
      />
    </svg>
  )
}

export default BackButton
